import React from 'react';

import styled from '@emotion/styled';
import { mq, grayBorder, green01, baseDurationTime } from '../../_style';
import Image from './image';

const Container = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 13px 0;
  border: 1px solid ${grayBorder};
  border-radius: 2px;
  background-color: #fff;
  transition: background-color ${baseDurationTime} ease;
  ${mq.pc} {
    &:hover {
      background-color: ${green01};
    }
  }
`;
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100%;
  height: 100%;
  max-width: 86px;
  max-height: 39px;
  opacity: ${props => props.isHover ? 0 : 1};
  transition: opacity ${baseDurationTime} ease;
  & > div {
    width: 100%;
  }
  ${mq.pc} {
    a:hover & {
      opacity: ${props => props.isHover ? 1 : 0};
    }
  }
`

export default class StoreBtn extends React.Component {
  render() {
    const imgPath = this.props.store === 'amazon' ? 'logo-amazon.png' : this.props.store === 'lohaco' ? 'logo-lohaco.png' : 'logo-rakuten.png'
    const imgPathHover = this.props.store === 'amazon' ? 'logo-amazon-hover.png' : this.props.store === 'lohaco' ? 'logo-lohaco-hover.png' : 'logo-rakuten-hover.png'
    if(this.props.href !== "") {
      return (
        <Container href={this.props.href} target="_blank">
          <ImageContainer>
            <Image filename={imgPath} alt={this.props.store}></Image>
          </ImageContainer>
          <ImageContainer isHover>
            <Image filename={imgPathHover} alt={this.props.store}></Image>
          </ImageContainer>
        </Container>
      );
    } else {
      return null;
    }
  }
}
